import { useEffect, useRef, useState } from 'react'
import { Box, Collapse } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import constants from '../../../../js/lib/constants'
import { useSelector, useDispatch } from 'react-redux'
import { setStep } from '../../../../js/lib/redux/slices/booking'
import SidebarCosts from './SidebarCosts'
import BookingChoices from './BookingChoices'
import isTransmissionAuto from '../../../../js/helpers/isTransmissionAuto'

const SummaryMobile = ({ showSummary, pricingData, handleContinue }) => {
  const { dictionary, records, pickUpDetails, dropOffDetails } =
    window.bookingData || window.modifyData

  const { brands, types } = records
  const { pageNumber, navigateTo } = constants.booking

  const navigate = useNavigate()

  const locale = document.documentElement.lang
  const [showDetails, setShowDetails] = useState(false)
  const [hasGrandTotal, setHasGrandTotal] = useState(false)
  const {
    step,
    selectedVehicle,
    isPrepaid: isPrepaidStore,
    modifiedPrices,
    mbData,
    type,
    milesNBonusAccount,
  } = useSelector((state) => state.booking)
  const dispatch = useDispatch()
  const sidebarRef = useRef(null)

  const { brandName, car } = selectedVehicle
  const { prepaidPrice, returnPrice } = car

  useEffect(() => {
    const sHeader = document.querySelector('.s-header')
    const sSummaryCollapsed = document.querySelector(
      '.s-extras-list__summary__panel'
    )

    if (sHeader && sidebarRef.current && sSummaryCollapsed) {
      // const sHeaderHeight = sHeader.offsetHeight
      const sSummaryCollapsedHeight = sSummaryCollapsed.offsetHeight
      // Use dvh (dynamic viewport height) for mobile browsers, fallback to vh
      sidebarRef.current.style.height = `calc(100dvh - ${sSummaryCollapsedHeight}px)`
      // Fallback for browsers that don't support dvh
      if (!CSS.supports('height', '100dvh')) {
        sidebarRef.current.style.height = `calc(100vh - ${sSummaryCollapsedHeight}px)`
      }
    }
  }, [sidebarRef, showSummary])

  const getBrand = () => {
    return brands?.find((b) => b.brandCode === brandName)
  }

  const prepaidIncludes = () => {
    const includes = prepaidPrice.prepaidIncludes.split(',')
    return includes
  }

  const returnIncludes = () => {
    const includes = returnPrice.returnIncludes.split(',')
    return includes
  }

  const handleEditExtras = () => {
    dispatch(setStep(pageNumber.extras))
    navigate(navigateTo.extras)
  }

  const handleChangeVehicle = () => {
    dispatch(setStep(pageNumber.vehicles))
    navigate(navigateTo.vehicles)
  }

  const toggleContent = () => {
    setShowDetails(!showDetails)
  }

  return (
    <div className="b-booking-sidebar" ref={sidebarRef}>
      <BookingChoices
        dictionary={dictionary}
        pickUpDetails={pickUpDetails}
        dropOffDetails={dropOffDetails}
      />

      <div className="b-booking-sidebar__header">
        <div className="b-booking-sidebar__header__model">
          <h2 className="h2">{car?.model}</h2>
          {car?.similarText && <span>{car?.similarText}</span>}
        </div>
        <div className="b-booking-sidebar__header__logo">
          {getBrand() && (
            <img
              src={getBrand().brandLogo}
              alt={getBrand().brandCode}
              loading="lazy"
            />
          )}
        </div>
      </div>

      <div className="b-booking-sidebar__body">
        <ul className="b-booking-sidebar__list">
          {selectedVehicle.passengers && (
            <li>
              <div className="pair">
                <i className="icon-passenger"></i>
                <span>{selectedVehicle.passengers}</span>
              </div>
            </li>
          )}
          {(selectedVehicle.smallLuggage > 0 ||
            selectedVehicle.bigLuggage > 0) && (
            <li>
              {selectedVehicle.bigLuggage > 0 && (
                <div className="pair">
                  <i className="icon-suitcase"></i>
                  <span>x{selectedVehicle.bigLuggage}</span>
                </div>
              )}
              {selectedVehicle.smallLuggage > 0 && (
                <div className="pair">
                  <i className="icon-suitcase"></i>
                  <span>x{selectedVehicle.smallLuggage}</span>
                </div>
              )}
            </li>
          )}
          {car?.acriss && (
            <li>
              <div className="pair">
                <i className="icon-transmission"></i>
                <span>
                  {isTransmissionAuto({ acriss: car?.acriss })
                    ? dictionary.transmissionAutomatic
                    : dictionary.transmissionManual}
                </span>
              </div>
            </li>
          )}
          <li>
            <div className="pair">
              <i className="icon-ac"></i>
              {selectedVehicle.ac ? (
                <span>{dictionary.acYes}</span>
              ) : (
                <span>{dictionary.acNo}</span>
              )}
            </div>
          </li>
          {car?.autonomy && (
            <li>
              <div className="pair">
                <i className="icon-battery-charging"></i>
                <span>{car?.autonomy}</span>
              </div>
            </li>
          )}
        </ul>
        <img
          className="b-booking-sidebar__car-image"
          src={car?.modelImage}
          alt={car?.model}
          loading="lazy"
        />

        {/* FIX BIG SUITCASE ICON !!!! */}
        <div className="b-booking-sidebar__view-details">
          <Collapse in={showDetails}>
            <Box className="b-booking-sidebar__view-details__content">
              <>
                <div className="b-booking-sidebar__divider--dashed"></div>
                <ul className="b-booking-sidebar__view-details__extras">
                  {isPrepaidStore
                    ? prepaidIncludes().map((extra, index) => (
                        <li key={index}>
                          <i className="icon-check"></i>
                          <span>{extra}</span>
                        </li>
                      ))
                    : returnIncludes().map((extra, index) => (
                        <li key={index}>
                          <i className="icon-check"></i>
                          <span>{extra}</span>
                        </li>
                      ))}
                </ul>
              </>
            </Box>
          </Collapse>
          <div
            className={`b-booking-sidebar__view-details__btn ${
              showDetails ? 'show' : ''
            }`}
            onClick={toggleContent}>
            {showDetails
              ? dictionary.asideHideDetails
              : dictionary.asideShowDetails}
            <i className="icon-arrow-down arrow" />
          </div>
        </div>

        <div className="b-booking-sidebar__divider"></div>

        <SidebarCosts
          step={step}
          mbData={mbData}
          selectedVehicle={selectedVehicle}
          modifiedPrices={modifiedPrices}
          isPrepaid={isPrepaidStore}
          type={type}
          milesNBonusAccount={milesNBonusAccount}
          handleEditExtras={handleEditExtras}
        />
      </div>

      {step !== pageNumber.payment && window.bookingData && (
        <div className="b-booking-sidebar__footer">
          {!selectedVehicle?.isGREngine && (
            <SanitizeHtml
              tag={'div'}
              className="b-booking-sidebar__footer__note"
              html={dictionary.asideNoteText}
            />
          )}

          <button
            type="submit"
            className="btn btn-primary btn-full-width"
            onClick={handleContinue}
            title={dictionary.asideProceedLabel}>
            {dictionary.asideProceedLabel}
          </button>
        </div>
      )}
    </div>
  )
}

export default SummaryMobile
